export default __webpack_public_path__ + "static/powerPointVirtualc-55097978ee6bac96669582dc75bb561e.jpg";